import { getRuntimeLocation } from './globalLocation';
import { ENVIRONMENTS, HOSTS } from 'shared/utils/environment/types';

export function isDevEnv(): boolean {
  return getEnvironment() === ENVIRONMENTS.DEVELOPMENT;
}

export function isProductionEnvironment(): boolean {
  return getEnvironment() === ENVIRONMENTS.PRODUCTION;
}

export function getEnvironment(): ENVIRONMENTS {
  const location = getRuntimeLocation();

  if (!location) {
    return ENVIRONMENTS.DEVELOPMENT;
  }

  const host = location.hostname as HOSTS;
  switch (host) {
    case HOSTS.INTEGRATION:
      return ENVIRONMENTS.INTEGRATION;
    case HOSTS.STAGING:
      return ENVIRONMENTS.STAGING;
    case HOSTS.PRODUCTION:
      return ENVIRONMENTS.PRODUCTION;
    default:
      return ENVIRONMENTS.DEVELOPMENT;
  }
}
